module.exports = __webpack_public_path__ + "img/storeTwo.ee4bcba8.png";